export default {
	freeTrial: {},
	rightFor: [],
	isPopUpNotAllowedVisible: false,
	// Indique si l'utilisateur s'est connecté via SSO (persisté via VuexPersist + localStorage)
	isSSO: false,
	user: {
		userId: "",
		username: "",
		token: "",
		diploma: "",
		first_name: "",
		last_name: "",
		levels: [],
		role: "",
		school: "",
		subjects: [],
		steps: [],
	},
	classes: [],
	levels: [],
	subjects: [],
	chapters: [],
	sequences: [],
	difficulties: [],
	evaluationTypes: [],
	questionTypes: [],
	questionThemes: [],
	resources: [],
	motifs: [],
	selectedOccurrence: {},
	exerciseQuestionTypes: [],
	exerciseQuestionThemes: [],
	academies: [],
	county: [],
	levelFilter: "",
	teacherFilter: "",
	currentPage: 0,

	dontShowAgainIndividual: false,
	showIndividual: false,
	showNoted: false,
	showKey: false,
	dontShowAgainKey: false,
	dontShowAgainShare: false,
	tileGameTeamsDisabled: null,
	tileGameTheme: {},
	nextCourses: [],
	isMenuToggled: true,
	toast: {
		status: "",
		text: "",
	},
	student: {
		id: "",
		username: "",
		token: "",
	},
	selectedFlashQuestions: [],
	selectedQCMQuestions: [],
};
